import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/agentShop_apply",
  name: "agentShop_apply",
  component: function component() {
    return import("../../../views/agentShop/agentShop_apply");
  },
  meta: {
    title: "推客店铺申请",
    foot: true
  }
}, {
  path: "/agentShop_manage",
  name: "agentShop_manage",
  component: function component() {
    return import("../../../views/agentShop/agentShop_manage");
  },
  meta: {
    title: "推客店铺管理",
    foot: true
  }
}, {
  path: "/agentShop_setting",
  name: "agentShop_setting",
  component: function component() {
    return import("../../../views/agentShop/agentShop_setting");
  },
  meta: {
    title: "推客店铺设置",
    foot: true
  }
}];